// Endpoints centralizados leidos desde variables de entorno (REACT_APP_*).
// Si alguna variable falta al bootear, lo notificamos con assertEnv() para
// fallar temprano en lugar de propagar undefined a las llamadas HTTP.

const env = (key: string): string => {
  const value = process.env[key]
  return value ?? ""
}

export const API_ENDPOINTS = {
  BASE: env("REACT_APP_API_SERVER_URL"),
  EGRESADOS: env("REACT_APP_API_SERVER_URL_EGRE"),
  EMPLEADOS: env("REACT_APP_API_SERVER_URL_EMPL"),
  EVENTOS: env("REACT_APP_API_SERVER_URL_EVENTOS"),
  RECIBOS: env("REACT_APP_API_SERVER_URL_RECIBOS"),
  ESTADISTICAS: env("REACT_APP_API_SERVER_URL_ESTADISTICAS"),
  VALID: env("REACT_APP_API_SERVER_URL_VALID"),
} as const

export const AUTH0_CONFIG = {
  AUDIENCE_ROL: env("REACT_APP_AUDIENCE_ROL"),
  ID_ROL_EMPL: env("REACT_APP_ID_ROL_EMPL"),
} as const

export const assertEnv = (): void => {
  const missing = Object.entries(API_ENDPOINTS)
    .filter(([, value]) => !value)
    .map(([key]) => key)

  if (missing.length > 0) {
    // eslint-disable-next-line no-console
    console.warn(
      `[config] Endpoints sin definir: ${missing.join(", ")}. ` +
        "Verificar variables REACT_APP_* en el entorno de build.",
    )
  }
}
